import React, { useCallback, useEffect } from 'react';
import { useController, useForm } from 'react-hook-form';
import classNames from 'classnames';
import IconButton from 'components/shared/IconButton';
import { CheckIcon, CloseIcon } from 'components/icons';
import useDeviceNameFormResolver from './hooks/useDeviceNameFormResolver';
import styles from './BundleOverviewControllerDeviceNameEditor.module.css';

function BundleOverviewControllerDeviceNameEditor({ name, onSubmit, onCancel, onError }) {
  const resolver = useDeviceNameFormResolver({ name });
  const methods = useForm({
    mode: 'onBlur',
    defaultValues: { name },
    resolver
  });
  const { control, handleSubmit, formState, clearErrors } = methods;
  const { errors } = formState;
  const {
    field: { value, onChange, onBlur },
    fieldState: { isDirty }
  } = useController({ name: 'name', control });

  const handleOnChange = useCallback(
    (e) => {
      onChange(e);
      clearErrors();
    },
    [onChange, clearErrors]
  );

  useEffect(() => {
    onError(errors);
  }, [errors, onError]);

  return (
    <div className={styles.root}>
      <div className={styles.control}>
        <input
          type="text"
          value={value}
          className={classNames({
            [styles.input]: true,
            [styles.inputError]: Object.keys(errors || {}).length > 0
          })}
          onBlur={onBlur}
          onChange={handleOnChange}
        />
        <IconButton
          aria-label="Submit"
          variant="contained"
          color="primary"
          size="x-small"
          className={styles.submit}
          disabled={!isDirty || Object.keys(errors) > 0}
          onClick={handleSubmit(onSubmit)}
        >
          <CheckIcon />
        </IconButton>
        <IconButton
          aria-label="Cancel"
          variant="outlined"
          color="primary"
          size="x-small"
          className={styles.cancel}
          onClick={onCancel}
        >
          <CloseIcon />
        </IconButton>
      </div>
    </div>
  );
}

export default BundleOverviewControllerDeviceNameEditor;
